import React from 'react';

import { Flex, Text } from '@lucidhq/lucidium';

import {
  AMPLITUDE_EVENTS,
  useAmplitude
} from '~/components/Shared/AmplitudeProvider';
import { NEW_UI_BANNER_HEIGHT } from '~/impact-measurement/constants';
import { t } from '~/utils/i18n';
import {
  buildMeasurementRedirectUrl,
  getMeasurementRedirectUrl
} from '~/utils/measurementRedirect';

export const isNewUiBannerVisible = () =>
  window.location.pathname.startsWith('/impact-measurement');

// Extra top offset for sticky/fixed elements stacked below the banner
export const getNewUiBannerOffset = () =>
  isNewUiBannerVisible() ? NEW_UI_BANNER_HEIGHT.px : 0;

export const NewUiBanner: React.FC = () => {
  const { trackEvent } = useAmplitude();

  if (!isNewUiBannerVisible()) {
    return null;
  }

  const href =
    getMeasurementRedirectUrl(window.location.pathname) ||
    buildMeasurementRedirectUrl('/studies');

  return (
    <Flex
      data-testid="new-ui-banner"
      lss={{
        position: 'sticky',
        top: 0,
        zIndex: 'header',
        height: NEW_UI_BANNER_HEIGHT.string,
        alignItems: 'center',
        justifyContent: 'center',
        px: 'md',
        bg: 'warning100'
      }}
    >
      <Text
        as="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent(AMPLITUDE_EVENTS.PREVIEW_NEW_UI)}
        lss={{
          color: 'gray900',
          textAlign: 'center',
          textDecoration: 'none',
          ':hover': { textDecoration: 'underline' }
        }}
      >
        {t('links.tryNewPlatform')}
      </Text>
    </Flex>
  );
};
